<ul class="list-group">
  <li class="list-group-item">
    <strong>Company Name</strong>
    <span class="float-end" name="companyName">{{customer.Name}}</span>
  </li>
  <li class="list-group-item">
    <strong>Customer ID</strong>
    <span class="float-end" name="customerId">{{customer.CustomerId}}</span>
  </li>
  @if (customer.Vertical) {
  <li class="list-group-item">
    <strong>Vertical</strong>
    <span class="float-end">{{customer.Vertical?.Name || 'N/A'}}</span>
  </li>
  }
  <li class="list-group-item">
    <strong>Partner Name</strong>
    <span class="float-end">{{customer.Partner.Name}}</span>
  </li>
  <li class="list-group-item">
    <strong>Language</strong>
    <span class="float-end">{{customer.Language.Name}}</span>
  </li>
  <li class="list-group-item">
    <strong>Country</strong>
    <span class="float-end">{{customer.Country.Name}}</span>
  </li>
  @if (parentTaskId) {
  <li class="list-group-item">
    <strong>Parent Task ID</strong>
    <span class="float-end" name="parentTaskId">{{ parentTaskId }}</span>
  </li>
  }
</ul>